module.exports = [
 {
  "start": 83,
  "end": 3500,
  "text": "In Sip My Ocean the mirroring of the projections"
 },
 {
  "start": 3542,
  "end": 6458,
  "text": " is referring to our almost mirrored body"
 },
 {
  "start": 6667,
  "end": 10708,
  "text": " as well to our craving to be in tune with the other humans."
 },
 {
  "start": 11000,
  "end": 14458,
  "text": "Also the lyrics of Chris Isaak treat the impossibility "
 },
 {
  "start": 14500,
  "end": 17208,
  "text": "to be in synchronisation with the others. "
 },
 {
  "start": 17333,
  "end": 20166,
  "text": "The song strikes a chord in many people "
 },
 {
  "start": 20250,
  "end": 22792,
  "text": "and at the moment we are sychronised; "
 },
 {
  "start": 23000,
  "end": 25792,
  "text": "a kind of mutual understanding of which art "
 },
 {
  "start": 26000,
  "end": 28458,
  "text": "can be a non-linguistic offer."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room2/audio1/02_1MCA Sip My Ocean.js